import React from "react";

const Contact = () => {
    return (
        <>
            <div className="Contact-block" id="Contact">
                <div className="container">
                    <div className="contact-inner">
                        <div className="title1" data-aos="fade-right">
                            <div className="title-inner">
                                <span>Location</span>
                                <h2>Contact Us</h2>
                            </div>
                        </div>
                        <div className="title2">
                            <div className="con-info">
                                <p>I'd love to hear from you! Please fill out the form below or send a note directly with as much details as possible to info@danhalsman.com</p>
                                <div className="item-c">
                                    <p>
                                        <b>Phone</b> : +1 650-444-0000
                                    </p>
                                </div>
                                <div className="item-c">
                                    <p>
                                        <b>Address</b> : 525 West Ave, CT 06850 Norwalk
                                    </p>
                                </div>
                                <div className="item-c">
                                    <p>
                                        <b>Email </b> : info@danhalsman.com
                                    </p>
                                </div>
                                <div className="item-c">
                                    <p>
                                        <b>Google Map</b> : <a href="#" target="_blank" rel="noreferrer"> Get Directions</a>
                                    </p>
                                </div>
                            </div>
                            <div className="con-form">
                                <p>
                                    <b>Get in touch</b>
                                </p>
                                <div className="form-info">
                                    <form action="submit">
                                        <div className="in-name">
                                            <input className="fname" type="text" name="fname" placeholder="Your Name*" />
                                        </div>
                                        <div className="in-email">
                                            <input type="email" className="Email" placeholder="Your Email*" name="email" />
                                        </div>
                                        <div className="in-text">
                                            <textarea name="msg" className="msg" rows="6" placeholder="Your Message"></textarea>
                                        </div>
                                        <div className="btn">
                                            <button type="button">submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Contact;